import React, { useEffect, useState } from 'react'

import style from './Timer.module.css'

import { useAppDispatch, useAppSelector } from 'common/hooks'
import { selectTimerStatus, setResults } from 'features/simulator'

export const Timer = () => {
  const dispatch = useAppDispatch()
  const timerStatus = useAppSelector(selectTimerStatus)

  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    if (timerStatus === 'finished') {
      dispatch(setResults(seconds))
    }
  }, [timerStatus])

  useEffect(() => {
    let timerId: ReturnType<typeof setInterval>

    setSeconds(0)

    if (timerStatus === 'active') {
      timerId = setInterval(() => {
        setSeconds(time => time + 1)
      }, 1000)
    }

    return () => {
      clearInterval(timerId)
    }
  }, [timerStatus])

  const secsString = String(seconds).length === 1 ? `0${String(seconds)}` : String(seconds)

  return (
    <div className={`${style.box} ${timerStatus === 'active' ? style['box--active'] : ''}`}>
      <div className={style.timer}>{`${secsString}`}</div>
    </div>
  )
}
